"use strict";

define('components/filter_bar/table/bulk_publish',["components/ajax"], function(ajax) {
  var bulkPublishComponent = {
    initWithContext: function(context) {
      var publishButton = context.buttonbarNode.find(
        ".selection-publish-bulk button"
      );
      bulkPublishComponent._initBulkButtonClick(context, publishButton);
    },

    _initBulkButtonClick: function(context, button) {
      button.click(function(e) {
        var objectIds = bulkPublishComponent._getSelectedObjectIds(context);
        // The csrf_token will be added in the ajax call below.
        var content = new FormData();
        content.append("transaction_ids", objectIds); // comma-separated IDs.

        ajax(button.data("url"), {
          formData: content
        });
      });
    },

    // use custom _getSelectedObjectIds bc custom way of getting ids due to checkbox in expando
    _getSelectedObjectIds: function(context) {
      var selected_object_ids = new Array();
      context.tableFilterBarData.tableContainer
        .find("tr > td.cell-checkbox > input")
        .filter(":checkbox")
        .filter(":checked")
        .each(function() {
          var split = $(this).context.id.split("_");
          var id = split[split.length - 1];
          selected_object_ids.push(id);
        });

      return selected_object_ids;
    }
  };

  return bulkPublishComponent;
});

